import React from 'react';

import PageLayout from '../../../components/PageLayout';

import Grayscale from './Grayscale';

async function action() {
  return {
    title: 'Grayscale',
    description:
      'Flux Tech | Fatal Studios | In Grayscale, If you are missing a leg, take the enemy’s. Available for Mac and PC.',
    chunks: ['grayscale'],
    component: (
      <PageLayout>
        <Grayscale />
      </PageLayout>
    ),
  };
}

export default action;
